module.exports = __webpack_public_path__ + "static/media/bg19.5181e98e.jpg";